// AIDEV-NOTE: mirrored by GlossaryTerm.sort_key for server-rendered lists — change both together.
// Articles are stripped before accents are folded so "él" (he) isn't mistaken for "el".
const LEADING_NOISE = {
  en: /^(?:[^\p{L}\p{N}]|the\s)+/u,
  es: /^(?:[^\p{L}\p{N}]|(?:the|el|la|los|las)\s)+/u,
};

const normalizeGlossaryTerm = (term?: string): string => (
  (term || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().toLowerCase()
);

export const glossaryTermSortKey = (term?: string, locale: Locale = 'en'): string => (
  normalizeGlossaryTerm(term)
    .replace(LEADING_NOISE[locale.toLowerCase() === 'es' ? 'es' : 'en'], '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
);

export const compareGlossaryTerms = (a?: string, b?: string, locale: Locale = 'en'): number => (
  glossaryTermSortKey(a, locale).localeCompare(glossaryTermSortKey(b, locale))
  || normalizeGlossaryTerm(a).localeCompare(normalizeGlossaryTerm(b))
);
